/** Identidade única do WL: nunca usa a logo da empresa contratante como marca do app. */
import { useState } from 'react';
import { useSystemSettings } from '@/hooks/useSystemSettings';
import { cn } from '@/lib/utils';

export function ProviderSystemBrand({ login = false, compact = false }: { login?: boolean; compact?: boolean }) {
  const { branding } = useSystemSettings();
  const [failed, setFailed] = useState<string[]>([]);
  const candidates = login
    ? [branding.login_logo_url, branding.logo_url, branding.icon_url]
    : [branding.logo_url, branding.icon_url];
  const src = candidates.find((url) => url && !failed.includes(url));
  // A logo WL vigente tem letras claras: superfície azul preserva contraste sem alterar a imagem.
  return <div className={cn('flex items-center justify-center bg-sidebar text-sidebar-foreground', compact ? 'h-12 w-36 shrink-0 px-1' : 'h-24 w-full rounded-md px-5 py-4')}>
    {src ? <img src={src} alt={branding.app_name} className="h-full max-w-full object-contain"
      onError={() => setFailed((old) => [...old, src])} />
      : <span className={cn('max-w-full truncate font-bold', compact ? 'text-sm' : 'text-3xl')}>{branding.app_name}</span>}
  </div>;
}